import { RepositoryFactory } from "../../repository/RepositoryFactory";
import { toast } from "react-toastify";
import firebase from "../../config/firebase";

const VeriffRepository = RepositoryFactory.get("veriff");

export const VERIFF_SESSION_REQUEST = "VERIFF_SESSION_REQUEST";
export const VERIFF_SESSION_SUCCESS = "VERIFF_SESSION_SUCCESS";
export const VERIFF_SESSION_FAIL = "VERIFF_SESSION_FAIL";
export const VERIFF_STATUS_UPDATE = "VERIFF_STATUS_UPDATE";
export const VERIFF_RESET = "VERIFF_RESET";

export const createVeriffSession = (userId) => {
  return async (dispatch) => {
    dispatch({ type: VERIFF_SESSION_REQUEST });

    try {
      const userDoc = await firebase
        .firestore()
        .collection("users")
        .doc(userId)
        .get();

      if (userDoc.exists) {
        const userData = userDoc.data();
        const currentStatus = userData.veriff?.status || userData.veriffStatus;

        if (
          currentStatus === "resubmission_requested" &&
          userData.veriff?.sessionUrl
        ) {
          dispatch({
            type: VERIFF_SESSION_SUCCESS,
            payload: {
              sessionId: userData.veriff.sessionId,
              verificationUrl: userData.veriff.sessionUrl,
            },
          });

          toast.info(
            "Reusing existing verification session. Please complete your document verification.",
          );

          return {
            sessionId: userData.veriff.sessionId,
            verificationUrl: userData.veriff.sessionUrl,
            success: true,
          };
        }

        if (
          currentStatus === "declined" ||
          currentStatus === "expired" ||
          currentStatus === "abandoned"
        ) {
          await firebase.firestore().collection("users").doc(userId).update({
            veriff: firebase.firestore.FieldValue.delete(),
            veriffStatus: "not_started",
          });
          const clearedUserData = {
            ...userData,
            veriff: null,
            veriffStatus: "not_started",
          };

          dispatch({
            type: "LOGIN_SUCCESS",
            user: { id: userId, ...clearedUserData },
            error: "",
          });

          toast.info(
            "Previous verification data cleared. Starting fresh verification...",
          );
        }
      }

      const response = await VeriffRepository.createSession({ userId });
      if (response.data.success) {
        dispatch({
          type: VERIFF_SESSION_SUCCESS,
          payload: {
            sessionId: response.data.sessionId,
            verificationUrl: response.data.verificationUrl,
          },
        });
        return response.data;
      } else {
        throw new Error(
          response.data.message || "Failed to create Veriff session",
        );
      }
    } catch (error) {
      dispatch({
        type: VERIFF_SESSION_FAIL,
        payload: error.message,
      });
      toast.error("Failed to create verification session. Please try again.");
      throw error;
    }
  };
};

export const listenToVeriffStatus = (userId) => {
  return (dispatch) => {
    const unsubscribe = firebase
      .firestore()
      .collection("users")
      .doc(userId)
      .onSnapshot((doc) => {
        if (doc.exists) {
          const userData = doc.data();

          let veriffStatus = userData.veriffStatus || "not_started";
          let veriffData = userData.veriffData || null;
          if (userData.veriff && userData.veriff.status) {
            veriffStatus = userData.veriff.status;
            veriffData = userData.veriff;
          }

          dispatch({
            type: VERIFF_STATUS_UPDATE,
            payload: {
              status: veriffStatus,
              veriffData: veriffData,
            },
          });
          const updatedUserData = {
            ...userData,
            veriffStatus: veriffStatus,
          };

          dispatch({
            type: "LOGIN_SUCCESS",
            user: { id: doc.id, ...updatedUserData },
            error: "",
          });
        }
      });

    return unsubscribe;
  };
};

export const resetVeriffState = () => ({
  type: VERIFF_RESET,
});

export const checkVeriffRequirement = (user) => {
  const veriffStatus = user?.veriffStatus;
  const needsVerification =
    !veriffStatus ||
    veriffStatus === "not_started" ||
    veriffStatus === "pending" ||
    veriffStatus === "review" ||
    veriffStatus === "resubmission_requested";

  return needsVerification;
};
